/**
 *
 * WorkflowBookingFilter
 *
 */
import { translations } from 'locales/translations';
import { useTranslation } from 'react-i18next';
import { Entity } from 'types/common';
import { IFilterComponentProps } from '../IFilterComponentProps';
import { WorkflowBookingPicker } from 'app/components/pickers/AutocompletePickers/WorkflowBookingPicker';

export const WorkflowBookingFilter = (props: IFilterComponentProps) => {
  const handleOnChange = (value: Entity<number> | null) => {
    props.onChange(value);
  };
  const { t } = useTranslation();
  return (
    <WorkflowBookingPicker
      value={props.value}
      onChange={handleOnChange}
      isOpen={props.open}
      placeholder={t(translations.AllValues)}
      size="small"
      ariaLabel={props.label}
      id={props.id}
    />
  );
};
export default WorkflowBookingFilter;
